import React from 'react';
import { Button } from 'antd';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { PlusOutlined } from '@ant-design/icons';
import comingImg from 'views/Aide/assets/coming.png';
import { useGetPermission } from 'hooks/business/useNewPermisson';

const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  button {
    margin-top: 24px;
  }
  img {
    height: 155px;
    width: 210px;
  }
`;

interface Props {
  onAdd: () => void;
}

const WhatsappAccountNodata = (props: Props) => {
  const { onAdd } = props;
  const { t } = useTranslate();

  const getPermission = useGetPermission();

  return (
    <Container>
      <img alt="" src={comingImg} />
      {getPermission('店铺管理') && (
        <Button icon={<PlusOutlined />} type="primary" onClick={onAdd}>
          {t('WhatsApp.添加帐号')}
        </Button>
      )}
    </Container>
  );
};

export default WhatsappAccountNodata;
